import { SkeletonLayout } from '@app/components/various/SkeletonLayout';
import { isDefined } from '@app/utils/is';
import { flexRender } from '@tanstack/react-table';
import { Tables } from '@typings';
import cx from 'classnames';

import { TextSkeleton } from './Skeletons';

export const TableFooter = <T,>({ table, isLoading }: Tables.FooterProps<T>) => {
  const hasFooter = table
    .getFooterGroups()
    .some(footerGroup => footerGroup.headers.some(header => isDefined(header.column.columnDef.footer)));

  if (!hasFooter) {
    return null;
  }

  return (
    <tfoot>
      {table.getFooterGroups().map(footerGroup => (
        <tr key={footerGroup.id}>
          {footerGroup.headers
            .filter(header => isDefined(header.column.columnDef.footer))
            .map(header => {
              const { meta, footer } = header.column.columnDef;

              return (
                <td
                  key={header.id}
                  className={cx('h-6 px-4 body-2 first:text-neutral-40 [&:not(:first-child)]:body-1', {
                    'justify-center text-center': meta?.align === 'center',
                    'justify-end text-right': meta?.align === 'right',
                    'justify-start text-left': !isDefined(meta?.align) || meta.align === 'left',
                  })}
                  colSpan={meta?.footerCellColspan ?? header.colSpan}
                >
                  <SkeletonLayout isLoading={isLoading} skeleton={<TextSkeleton />}>
                    {flexRender(footer, header.getContext())}
                  </SkeletonLayout>
                </td>
              );
            })}
        </tr>
      ))}
    </tfoot>
  );
};
